import { tasks } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { ITasks } from "../../models/master/task";

export default new (class TaskService {
  public getTask = async (id: number): Promise<IApiResponse<ITasks>> => {
    try {
      let endPoint = urlBinder(tasks.GET_TASK, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ITasks>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ITasks>;
      } else {
        throw error;
      }
    }
  };

  public getTasks = async (
    noOfItems?: number
  ): Promise<IApiResponse<Array<ITasks>>> => {
    try {
      let endPoint = urlBinder(tasks.GET_ALL_TASKS,[noOfItems]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<ITasks>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<ITasks>>;
      } else {
        throw error;
      }
    }
  };

  public createTask = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = tasks.CREATE_TASK;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateTask = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(tasks.UPDATE_TASK, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteTask = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(tasks.DELETE_TASK, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
